import { ChipLabel } from '@atoms/chipLabel';

import { ChevronRight, MoveRight, X } from 'lucide-react';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import DocumentIcon from '@/assets/svg/document.svg?react';

import { HeaderContainer, Navbar, StyledNavLink } from './panelHeader.style';
import type { TabLink } from './panelHeader.types';

type HeaderProps = {
  workflowName: string;
  infos: string[];
  actionType: string;
  tabLinks?: TabLink[];
};
const ICON_SIZE = '0.8em';
const PanelHeader = ({
  workflowName,
  infos,
  actionType,
  tabLinks = []
}: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <section className="flex min-h-0 w-full grow items-start justify-between">
        <div className="flex flex-row items-center gap-3 text-[15px] text-gray-dark">
          <i className="inline-flex select-none items-center rounded-[3px] p-[5px] text-center outline outline-1 outline-light">
            <DocumentIcon />
          </i>
          <div>{workflowName}</div>
          <ChevronRight size={ICON_SIZE} />
          {infos.map((info, index) => (
            <Fragment key={index}>
              <div> {info} </div>
              {index < infos.length - 1 && <MoveRight size={ICON_SIZE} />}
            </Fragment>
          ))}
          <ChipLabel>{actionType}</ChipLabel>
        </div>
        <div
          className="group absolute top-3 right-3 flex cursor-pointer items-center justify-center rounded-full p-6"
          onClick={() => navigate('../..')}
        >
          <X className="text-gray-700 group-hover:text-gray-800" size={19} />
        </div>
      </section>
      <Navbar>
        <ul>
          {tabLinks.map((tabLink, index) => (
            <li key={index}>
              <StyledNavLink $fontFamily={tabLink.fontFamily} to={tabLink.path}>
                {tabLink.content}
              </StyledNavLink>
            </li>
          ))}
        </ul>
      </Navbar>
    </HeaderContainer>
  );
};

export default PanelHeader;
